import React, { useContext } from "react";
import { Link } from "react-router-dom";
import SideMenuContext from "./../../../src/common/context/sideMenuContext";
import { loadImage } from "./../../../src/common/services/uiService";
import "./../styles/sideMobileMenu.css";

const SideMobileMenu = (props) => {
  const sideMenuContext = useContext(SideMenuContext);
  const menues = sideMenuContext.menues;
  //const { isVisible } = this.state;
  const overlayClassName = props.showsideMobileMenu
    ? "overlay active"
    : "overlay";
  //const overlayClassName = `overlay ${this.props.showsideMobileMenu ? 'active' : ''} ${this.state.exiting ? 'exiting' : ''}`;

  function handleClickAnimation(event) {
    //sessionStorage.setItem('CurrentMouseLocation',event.pageX + "," + event.pageY);
    //props.updateVisibility();
    /*
        var sideMenuDiv = document.getElementById('SideMenu');
        
        if(sideMenuDiv !== undefined)
        {
          console.log('sideMenuDiv !== undefined');
    
          sideMenuDiv.style.animationName = "pageAnimationSideBarMobile";
          sideMenuDiv.hidden = "true";
        }
        */
    //props.showsideMobileMenu = 'false';
  }

  function onMouseOver(event) {
    if (event.target.tagName === "LI") {
      var selectAttr = event.target.select;
      if (selectAttr === "false") {
        event.target.className = event.target.id;
        console.log(event.target.className);
      }
    } else {
      var selectAttr = event.target.parentElement.parentElement.select;
      if (selectAttr === "false") {
        event.target.parentElement.parentElement.className =
          event.target.parentElement.parentElement.id;
        console.log(event.target.parentElement.parentElement.className);
      }
    }
  }

  function onMouseOut(event) {
    /*if(event.target.tagName === 'LI')
        {
          var selectAttr = event.target.getAttribute('select');
          if(selectAttr === 'false')
          {
            event.target.className = 'SideMenuLink';
          }
        }
        else{
          var selectAttr = event.target.parentElement.parentElement.getAttribute('select');
          if(selectAttr === 'false')
          {
            event.target.parentElement.parentElement.className = 'SideMenuLink';
          }
        }*/
  }

  return (
    <React.Fragment>
      {props.showsideMobileMenu && (
        <div id="overlayDiv" className={overlayClassName}>
          {menues.map((mItem, ind) => {
            const isActive = props.currentLocation === mItem.to;
            const iconImg =
              mItem.activeImg?.length &&
              mItem.nonActiveImg?.length &&
              // loadImage(isActive ? mItem.activeImg : mItem.nonActiveImg);
              loadImage(mItem.activeImg);
            return (
              <div key={Math.random(100) * ind}>
                {mItem.beforeSpace && (
                  <div className={mItem.beforeSpaceClass}>
                    {mItem.beforeTitle && (
                      <p className={mItem.beforeTitleClass}>
                        {mItem.beforeTitle}
                      </p>
                    )}
                  </div>
                )}
                <Link
                  to={{ pathname: mItem.to, state: "flushDeal" }}
                  key={mItem.id}
                  onClick={() => {
                    props.handleClick(mItem);
                  }}
                >
                  <li
                    id={mItem.activeClassName}
                    select={isActive ? "true" : "false"}
                    className={
                      isActive ? mItem.activeClassName : mItem.regClassName
                    }
                    key={mItem.id}
                    onMouseOver={onMouseOver}
                    onMouseOut={onMouseOut}
                  >
                    {iconImg ? (
                      <span className="sideMenuImg">
                        <img src={iconImg} alt={mItem.Title} />
                        <span className="menuItemId">{mItem.id}</span>
                        {/* {isActive ? (
                    <img src={loadImage(mItem.activeImg)} alt={mItem.Title} />
                    ) : (
                      <img
                        src={loadImage(mItem.nonActiveImg)}
                        alt={mItem.Title}
                      />
                    )} */}
                      </span>
                    ) : null}
                    <span>
                      <span
                        className={
                          isActive
                            ? mItem.activeTitleClassName
                            : mItem.regTitleClassName
                        }
                      >
                        {mItem.title}
                      </span>
                    </span>
                    {/* </a> */}
                  </li>
                </Link>
              </div>
            );
          })}
        </div>
      )}

      {/*<div id="overlayDiv" className={overlayClassName}>
                    <ul>
                        <li><a href="/page1">Page 1</a></li>
                        <li><a href="/page2">Page 2</a></li>
                    </ul>
            </div>)*/}
    </React.Fragment>
  );
};

export default SideMobileMenu;
